import { useMemo, useState } from 'react';

const useActivePlan = plan => {
	const [selectedSeat, setSelectedSeat] = useState(plan.hasSeatSelection ? plan.seats[0] : null);

	const activePlan = useMemo(() => {
		return plan.hasSeatSelection && selectedSeat ? selectedSeat : plan;
	}, [plan, selectedSeat]);

	return { activePlan, selectedSeat, setSelectedSeat };
};

export default useActivePlan;
